import $config from '@/config'
import feathers from '@feathersjs/client'
import io from 'socket.io-client'
import store from '@/store'
import logger from '@/api/logger'
import eventLog from '@/api/eventLog'
const socket = io($config.feathersServer, { transports: ['websocket'], upgrade: false })
//const socket = io($config.feathersServer)
import { CookieStorage } from 'cookie-storage';
 
const cookieStorage = new CookieStorage();

const feathersClient = feathers()

feathersClient.configure(feathers.socketio(socket));
feathersClient.configure(feathers.authentication({ storage: cookieStorage, cookie: 'feathers-jwt'}))

socket.on('connect', function(){
});

feathersClient.io.on('connect', function() {

  /* if we loose socket conncetion during watch sent to stream session-connection data to new socket connection after re-connect*/
  if(feathersClient.subscribe){
    feathersClient.io.emit('subscribe', feathersClient.subscribe);
  }

  /* Reload webcast and qna data */
  if(store.state.webcast.copy){
    store.dispatch('webcast/get', store.state.webcast.copy._id).then((wc)=>{
      store.commit('webcast/setCurrent', wc);
      store.dispatch('qna/find', {
        webcastId: wc._id
      }).then((qnaList)=>{
      });
    });
  } else {
  }

  
  
});

socket.on('disconnect', function() {
  console.log("disconnected");
  
});

export default feathersClient